import Index from './index.vue'
import List from './list.vue'
import Uploader from './uploader'

const basePath = '/v-admin/application/:jobId/batch-upload'

export default {
  name: 'batchUploadCandidateIndex',
  path: `${basePath}`,
  component: Index,
  redirect: `${basePath}/uploader`,
  meta: {
    titleI18nKey: 'admin.application.batchUpload.title.uploader'
  },
  children: [
    {
      name: 'batchUploadCandidateHistory',
      path: `${basePath}/history`,
      component: List,
      meta: {
        isUploader: false,
        titleI18nKey: 'admin.application.batchUpload.title.history'
      }
    },
    {
      name: 'batchUploadCandidateUploader',
      path: `${basePath}/uploader`,
      component: Uploader,
      meta: {
        isUploader: true,
        titleI18nKey: 'admin.application.batchUpload.title.uploader'
      }
    }
  ]
}
